import type { GruppoAllegati, IstanzaSezioneDati } from '@framework/api-client';
import styled from 'styled-components';
import { getAnchorId } from './getAnchorId';

const DeclarationContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  margin-bottom: 1rem;
`;

const DeclarationLine = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  flex: 1 1 auto;
  min-width: 10%;
`;

const Stroke = styled.div`
  display: flex;
  height: 1px;
  width: 100%;

  border-bottom: 1px solid ${props => props.theme.colorPrimary};
`;

const DeclarationText = styled.div`
  display: inline-flex;
  flex: 0 0 auto;
  min-width: 0;
  max-width: 90%;
  font-size: 18px;
  line-height: 1.3;
  font-weight: 500;
  color: ${props => props.theme.colorPrimary};
  padding-right: 1rem;
`;

export interface DeclarationTitleProps {
  declaration?: IstanzaSezioneDati | null;
  attachments?: GruppoAllegati | null;
  /**
   * Permette di generare un Titolo con lo stile del titolo della dichiarazione
   * L'Id viene dal titolo inserito ma non è gestita
   * la generazione degli Anchor (TaskStateAnchors)
   */
  title?: string;
}

/**
 * Evidenziazione del titolo della dichiarazione
 * Per ogni titolo viene generato un id Html che è utilizzato
 * per la navigazione con gli Anchor nella pagina dei Task (TaskStateAnchors)
 */
export function DeclarationTitle(props: DeclarationTitleProps) {
  if (!props.declaration && !props.title) {
    return null;
  }
  const title = props.declaration
    ? props.declaration.titoloSezioneDati
    : props.title;
  const id =
    props.declaration?.idSezioneDati ??
    props.attachments?.idGruppoAllegato ??
    props.title;
  return (
    <DeclarationContainer>
      <DeclarationText id={getAnchorId(id)}>{props.title}</DeclarationText>
      <DeclarationLine>
        <Stroke />
      </DeclarationLine>
    </DeclarationContainer>
  );
}
